<template>
  <loading v-if="listLoading"></loading>
  <div class="contain5" v-else>
    <div class="contain-big113" v-if="list.length>0">
      <!-- <div class="contain-title">
        <span>技能课程</span>
        <img src="../../../assets/image/list.png" alt="">
      </div> -->
      <div class="contain-list">
          <div class="contain-list-box" v-for="(item,index) in list" :key="index" @click="goSchoolDetails(item.other_course_school_id)">
              <div class="contain-list-box-title">
                <div class="contain-list-box-title-type"><div>课程</div><span>{{item.other_course_school.other_course.name}}</span></div>
                <img src="../../../assets/image/black_go.png" alt="">
              </div>
              <!-- 内容 -->
              <div class="contain-list-box-content1" v-html="item.other_course_school.other_course.details"></div>
              <!-- 时间 -->
              <div class="contain-list-box-time">
                <div class="contain-list-box-time-left">
                  <div>{{item.other_course_school.start_school_year}}-{{item.other_course_school.end_school_year}}年度</div>
                  <div>{{item.semester==1?'第一学期':'第二学期'}}</div>
                </div>
                <div class="contain-list-box-time-right">
                  <img src="../../../assets/image/class_hour.png" alt="">
                  <span>共{{item.other_course_school.other_course.total_class_hour}}课时</span>
                </div>
              </div>
              <!-- 价格 -->
              <div class="contain-list-box-price">
                <div class="contain-list-box-price-left"><span>￥</span><span>{{item.other_course_school.other_course.price}}</span></div>
                <el-button type="info" size="small">已报名</el-button>
              </div>
          </div>
      </div>
      <div class="pagination-container">
        <!-- <el-pagination :current-page="listQuery.page" :page-sizes="[10,20,30, 50]" :page-size="listQuery.limit" :total="total" background layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange"/> -->
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="query.page"
            :page-size="query.limit"
            background
            :pager-count="5"
            layout="prev, pager, next"
            :total="total">
          </el-pagination>
      </div> 
    </div>
    <noData v-else></noData>
  </div>
</template>
<script>
import request from "@/utils/request";
import loading from '@/components/loading/loading.vue'
import noData from '@/components/noData/index.vue'
export default {
  components: { loading ,noData},
  data(){
    return{
      listLoading:true,
      list:[],
      total:0,
      query:{
        page:1,
        limit:10
      }

    }
  },
  created(){
    if(this.$store.getters.getUserInfo.student_id){
      this.getList()
    }
  },
  methods:{
    richTextFormat(value) {
      // value = value.replace(/<\/?[^>]*>/g,'')
      value = value.replace(/<\/?.+?>/g,'')
        value = value.replace(/\s+/g,'')
        if (value.length > 90) {
          return value.slice(0, 90) + "...";
        }
        return value;
    },
      handleSizeChange(val) {
        this.query.limit = val;
        this.getList();
      },
      handleCurrentChange(val) {
        this.query.page = val;
        this.getList();
      },
      goSchoolDetails(id){
        this.$router.push({
          path:"/school/details",
          query:{
            id:id
          }
        })
      },
    getList() {
      this.listLoading = true;
      request({
        url: "/api/userend/user/otherCourseEnroll",
        method: "get",
        params: this.query
      }).then(response => {
        this.list = response.data.data;
        this.list.forEach(item=>{
          item.other_course_school.other_course.details=this.richTextFormat(item.other_course_school.other_course.details)
        })
        this.listLoading = false;
        this.total=response.data.total
      });
    },
  }
}
</script>
<style lang="scss" scoped>
.contain5{
  .contain-big113{
    padding: 20px 20px;
    background: #FFFFFF;
    border-radius: 8px;
    .pagination-container{
      margin-top: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
  }
  .contain-title{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-content: center;
    span{
      font-size: 28px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #1E2134;
    }
    img{
      width: 129px;
      height: 77px;
    }
  }  
  .contain-list:after {
    display:block;
    content:"";
    width: 30%;
    height:0px;
}
  .contain-list{
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-between;
      width: 100%;
      .contain-list-box{
        cursor: pointer;
        margin-top: 20px;
        padding: 15px 20px;
        width: 30%;
        background: #FFFFFF;
        box-shadow: 0px 2px 15px 3px rgba(220, 220, 220, 0.16);
        border-radius: 8px;
        border: 1px solid #F9FAFD;
        .contain-list-box-title{
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          .contain-list-box-title-type{
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
            div{
              text-align: center;
              width: 38px;
              height: 19px;
              background: #3D7EFF;
              border-radius: 11px;
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #FFFFFF;
              line-height: 19px;
            }
            span{
              font-size: 20px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #1E2134;
              margin-left: 5px;
            }
          }
          img{
            width: 18px;
            height: 18px;
          }
        }
        .contain-list-box-content1{
          height: 48px;
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #757575;
          line-height: 22px;
          margin-top: 15px;
        }

        .contain-list-box-time{
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          margin-top: 20px;
          .contain-list-box-time-left{
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            div{
              font-size: 16px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              &:nth-child(2){
                margin-left: 6px;
              }
            }
          }
          .contain-list-box-time-right{
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
            img{
              width: 18px;
              height: 18px;
            }
            span{
              font-size: 16px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #3D7EFF;
              margin-left: 5px;
            }
          }
        }
        .contain-list-box-price{
          margin-top: 40px;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          .contain-list-box-price-left{
            span{
              &:nth-child(1){
                font-size: 20px;
                font-family: SFProDisplay-Semibold, SFProDisplay;
                font-weight: 600;
                color: #F24342;
              }
              &:nth-child(2){
                font-size: 20px;
                font-family: SFProDisplay-Semibold, SFProDisplay;
                font-weight: 600;
                color: #F24342;
              }
            }
          }
        }
      }
    }
}
 .dialog{
        border-radius: 20px;
        position: relative;
    }
}
</style>